<tyl-mat-menu image="Copy.png"
	[label]="forFilters ? 'Filters' : 'Queries' "
	[topMenuItems]="menuItems()"
	[disabledTopMenuItems]="disabledQueryOptions"
	(menuClick)="menuClick($event)"></tyl-mat-menu>